export const FETCH_LOAD_TEMPLATE_BY_ID_REQUEST = 'FETCH_LOAD_TEMPLATE_BY_ID_REQUEST'
export const FETCH_LOAD_TEMPLATE_BY_ID_SUCCESS = 'FETCH_LOAD_TEMPLATE_BY_ID_SUCCESS'
export const FETCH_LOAD_TEMPLATE_BY_ID_FALUIRE = 'FETCH_LOAD_TEMPLATE_BY_ID_FALUIRE'
